// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { ApplicationLoader } from "../../../components/ApplicationLoader";
import { jsx as _jsx } from "react/jsx-runtime";
export const DomainLauncherListList = props => {
  const {
    loading,
    items
  } = props;
  return loading ? /*#__PURE__*/_jsx(ApplicationLoader, {
    "data-sentry-element": "ApplicationLoader",
    "data-sentry-component": "DomainLauncherListList",
    "data-sentry-source-file": "DomainLauncherListList.tsx"
  }) : items;
};